import BaseGradientColor from './GradientColor';

// EXPORT
export const GradientColor = BaseGradientColor;
export type { GradientColorProps } from './GradientColor.interface';
